import {
  getPartSubstituteCollections,
  addPartToSubstituteCollection,
  removeItemFromSubstituteCollection,
  createSubstituteCollection,
  mergeSubstituteCollections,
  getCertainSubstituteByPart
} from '@/api/part/part-substitute'

export default {
  state: {
    substituteCollections: {},
    partSubstituteCollectionRelations: {}
  },
  getters: {
    getSubstituteCollectionById: (state) => (substituteCollectionId) => {
      return state.substituteCollections[substituteCollectionId]
    },
    getSubstituteCollectionsByPart: (state) => (partId) => {
      let result = []
      if (state.partSubstituteCollectionRelations[partId]) {
        // @see https://stackoverflow.com/questions/35969974/foreach-is-not-a-function-error-with-javascript-array
        [...state.partSubstituteCollectionRelations[partId]].forEach(function (substituteCollectionId) {
          result.push(state.substituteCollections[substituteCollectionId])
        })
      }
      return result
    }
  },
  mutations: {
    setSubstituteCollections (state, substituteCollections) {
      state.substituteCollections = Object.assign({}, state.substituteCollections, _.keyBy(substituteCollections, 'id'))
    },
    setPartSubstituteCollectionRelationship (state, { partId, substituteCollectionIds }) {
      let value = null
      if (!state.partSubstituteCollectionRelations[partId]) {
        value = { [partId]: substituteCollectionIds }
      } else {
        value = { [partId]: _.uniq([...state.partSubstituteCollectionRelations[partId], ...substituteCollectionIds]) }
      }

      state.partSubstituteCollectionRelations = Object.assign({}, state.partSubstituteCollectionRelations, value)
    },
    removeItemFromSubstituteCollection (state, { substituteCollectionId, itemId }) {
      _.remove(state.substituteCollections[substituteCollectionId].items, { id: itemId })
      state.substituteCollections = Object.assign(
        {},
        state.substituteCollections,
        { [substituteCollectionId]: state.substituteCollections[substituteCollectionId] }
      )
    }
  },
  actions: {
    loadPartSubstituteCollections ({ commit }, partId) {
      return getPartSubstituteCollections(partId).then(resp => {
        commit('setSubstituteCollections', resp.data)
        commit('setPartSubstituteCollectionRelationship', { partId: partId, substituteCollectionIds: _.map(resp.data, 'id') })
        return resp
      })
    },
    addItemToSubstituteCollection ({ commit }, { substituteType, substituteId, partId }) {
      return addPartToSubstituteCollection(substituteType, substituteId, partId).then(resp => {
        commit('setSubstituteCollections', [resp.data])
        return resp
      })
    },
    deleteItemFromSubstituteCollection ({ commit }, { substituteType, substituteCollectionId, itemId }) {
      return removeItemFromSubstituteCollection(substituteType, itemId).then(resp => {
        if (resp.data.result === true) {
          commit('removeItemFromSubstituteCollection', { substituteCollectionId: substituteCollectionId, itemId: itemId })
        }
        return resp
      })
    },
    createPartSubstituteCollection ({ commit }, { description, substituteType, basePartId, specification = '', partIds = null, partCategoryId = null }) {
      return createSubstituteCollection(description, substituteType, basePartId, specification, partIds, partCategoryId).then(resp => {
        commit('setSubstituteCollections', [resp.data])
        commit('setPartSubstituteCollectionRelationship', { partId: basePartId, substituteCollectionIds: _.map([resp.data], 'id') })
        return resp
      })
    },
    mergeSubstituteTypeSubstituteCollections ({ commit }, { substituteType, primarySubstituteId, secondarySubstituteId }) {
      return mergeSubstituteCollections(substituteType, primarySubstituteId, secondarySubstituteId).then(resp => {
        commit('setSubstituteCollections', [resp.data])
        return resp
      })
    },
    loadCertainSubstituteByPart ({ commit }, { substituteType, partId }) {
      return getCertainSubstituteByPart(substituteType, partId).then(resp => {
        commit('setSubstituteCollections', resp.data)
        return resp
      })
    }
  }
}
